module.exports = __webpack_public_path__ + "img/126.0dba8bf1.png";